import React, { ReactElement } from "react";
import colors from "../../theme/colors/Colors.palette";
import { DefaultLogoProps, ILogoProps } from "./Logo.types";

const renderLogo = (props: ILogoProps): ReactElement<React.FC> => {
  const { color, width } = props;

  return (
    <div style={{ width: `${width}px` }}>
      <a href="https://www.consumersenergy.com/">
        <svg viewBox="-1 -1 28 28" version="1.1">
          <g>
            <g>
              <path
                fill={colors.Brand.primary}
                stroke={color}
                strokeWidth={1.3877}
                d="M12.5,0C19.4,0,25,5.6,25,12.5S19.4,25,12.5,25S0,19.4,0,12.5l0,0C0,5.6,5.6,0,12.5,0"
              />
              <path
                fill={color}
                d="M9.3,10c0.1-0.5,0.3-1.4-0.4-1.4C8,8.6,7.8,9.2,7,12.5c-0.8,3.4-0.8,3.9,0.1,3.9c0.6,0,0.9-0.5,1.3-2l0.2-0.9
			H12l-0.2,0.7c-0.6,2.7-2.2,4.3-5.3,4.3c-4.6,0-4-2.3-3.2-6.1c0.8-3.6,1.4-6.1,6-6.1c3.8,0,3.8,1.9,3.4,3.7L12.5,11H9.1L9.3,10z"
              />
              <path
                fill={color}
                d="M14.6,6.7h7.6l-0.6,2.6h-4.1l-0.4,1.8h3.8l-0.6,2.6h-3.8l-0.5,2h4.2l-0.6,2.6h-7.8L14.6,6.7z"
              />
            </g>
          </g>
        </svg>
      </a>
    </div>
  );
};

const MOBILE_LOGO: React.FC<ILogoProps> = (props: ILogoProps) => {
  return renderLogo(props);
};

MOBILE_LOGO.defaultProps = DefaultLogoProps;
export default MOBILE_LOGO;
